import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { filter } from 'helpers/decorators'
import { Input, InputDate, Select } from 'components/fields'
import { Col, FilterActions, Module, Row } from 'components/misc'
import { tasks as tasksApi } from 'redux/modules/api'
import { apiCodeLists, apiConfiguration, apiLabels, apiOrganizations } from 'helpers/decorators/api'
import { FilterByCountry } from 'containers/filters/fields'
import { CONFIGURATION_KEYS, LABEL_CATEGORY_TYPES, ORGANIZATION_HIERARCHY } from '../../../constants/enums'
import { mapAwardUnits, mapLabels } from '../../../helpers/mapForSelect'
import { get } from 'lodash'


const enhance = compose(
  apiCodeLists(['awardLevelTypes', 'awardModes']),
  apiOrganizations(),
  apiConfiguration(),
  apiLabels(),
  connect(
    ({ api }) => ({
      query: api.tasks.awardSignoff.office.filter,
      count: api.tasks.awardSignoff.office.count
    }),
    { setFilter: tasksApi.awardSignoff.setAwardOfficeSignoffFilter }
  ),
  filter({
    form: 'awards-office-signoff-filter',
    persist: true
  })
)

class FilterAwardsOfficeSignoff extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    isOffline: PropTypes.bool,
    showCountry: PropTypes.bool,
    getCustomOrganizations: PropTypes.func.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired,
    searchLabels: PropTypes.func
  }
  static defaultProps = {
    isOffline: false
  }

  searchAUorIAC = search => {
    const { activeOrganization } = this.props
    const params = { limit: 50 }

    if (search && search.name) {
      params.filter = `or(name ic ${search.name})`
    }

    return this.props.getCustomOrganizations(params,
        `flatHierarchy.parentOrganization.id=${activeOrganization.id},or(organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.AU.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.IAC.id})`, {}, {
          onlyActive: true,
          disableLimit: false
        })
        .then(obj => obj.body)
        .then(obj => mapAwardUnits({ list: obj }))
  }

  searchOrganizationPersonLabels = search => {
    const params = { limit: 50 }

    if (search && search.name) {
      params.filter = `or(name ic ${search.name})`
    }

    const orgId = get(this.props.activeOrganization, 'id')
    return this.props.searchLabels(LABEL_CATEGORY_TYPES.PERSON.id, params, orgId)
        .then(obj => obj.body)
        .then(obj => mapLabels(obj))
  }

  searchOrganizationLabels = search => {
    const params = { limit: 50 }

    if (search && search.name) {
      params.filter = `or(name ic ${search.name})`
    }

    const orgId = get(this.props.activeOrganization, 'id')
    return this.props.searchLabels(LABEL_CATEGORY_TYPES.ORGANIZATION.id, params, orgId)
      .then(obj => obj.body)
      .then(obj => mapLabels(obj))
  }

  searchOrganizationContactLabels = search => {
    const params = { limit: 50 }

    if (search && search.name) {
      params.filter = `or(name ic ${search.name})`
    }

    const orgId = get(this.props.activeOrganization, 'id')
    return this.props.searchLabels(LABEL_CATEGORY_TYPES.CONTACT.id, params, orgId)
      .then(obj => obj.body)
      .then(obj => mapLabels(obj))
  }

  searchOrganizationAwardLabels = search => {
    const params = { limit: 50 }

    if (search && search.name) {
      params.filter = `or(name ic ${search.name})`
    }

    const orgId = get(this.props.activeOrganization, 'id')
    return this.props.searchLabels(LABEL_CATEGORY_TYPES.AWARD.id, params, orgId)
      .then(obj => obj.body)
      .then(obj => mapLabels(obj))
  }

  render() {
    const { codeLists, isOffline, showCountry, configuration, activeOrganization } = this.props

    const isLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)

    const isOrgLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableOrganizationLabels.id}].booleanValue`)

    const isContactLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableContactLabels.id}].booleanValue`)

    const isAwardLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableAwardLabels.id}].booleanValue`)

    return (
      <Module verticallyNarrow primary>
        <Row alignItems="center" gutters inner>
          <Col flex="0 1 200px">
            <Input
              label="Search"
              intlKey="label.search"
              name="award_participant_id||award_participant_firstName||award_participant_lastName||award_participant_email@ic"
            />
          </Col>
          <Col flex="0 1 200px">
            <Select
              label="Current Award"
              name="award_awardLevel_value@or"
              intlKey="label.current_award"
              options={codeLists.awardLevelTypes.list}
              multi
            />
          </Col>
          <Col flex="0 1 200px">
            <InputDate
              label="Submitted after"
              intlKey="label.submitted_after_date"
              name="award_leaderSignoffDate@ge"
            />
          </Col>
          {isOffline &&
          <Col flex="0 1 200px">
            <Select
              label="Award mode"
              name="award_awardMode_value@or"
              intlKey="label.award_mode"
              options={codeLists.awardModes.list}
              multi
            />
          </Col>}
          {showCountry &&
            <Col flex="0 1 200px">
              <FilterByCountry name="award_organization_country_id@or" multi />
            </Col>
          }

          <Col flex="0 1 200px">
            <Select
                label="Award Centre"
                intlKey="label.award_unit"
                name="organization_id@or"
                multi
                autocomplete
                promise={this.searchAUorIAC}
                placeholder="Start typing ..."
                intlKeyPlaceholder="placeholder.start_typing"
                backspaceToRemoveMessage={''}
            />
          </Col>

          {isLabelsEnabled && <Col flex="0 1 120px">
            <Select
              label="Participant Label"
              intlKey="label.label"
              name="award_participant_labels_label_id@or"
              multi
              autocomplete
              promise={this.searchOrganizationPersonLabels}
              placeholder="Start typing ..."
              intlKeyPlaceholder="placeholder.start_typing"
              backspaceToRemoveMessage={''}
            />
          </Col>}

          {isOrgLabelsEnabled && <Col flex="0 1 120px">
            <Select
              label="Organization Labels"
              intlKey="label.organization_labels"
                name="award_organization_labels_label_id@or"
                multi
                autocomplete
                promise={this.searchOrganizationLabels}
                placeholder="Start typing ..."
                intlKeyPlaceholder="placeholder.start_typing"
                backspaceToRemoveMessage={''}
            />
          </Col>}

          {isContactLabelsEnabled && <Col flex="0 1 120px">
            <Select
              label="Award Leader Label"
              intlKey="label.contact_label"
              name="award_awardLeader_labels_label_id@or"
              multi
              autocomplete
              promise={this.searchOrganizationContactLabels}
              placeholder="Start typing ..."
              intlKeyPlaceholder="placeholder.start_typing"
              backspaceToRemoveMessage={''}
            />
          </Col>}

          { isAwardLabelsEnabled && <Col flex="0 1 120px">
            <Select
              label="Award Label"
              intlKey="label.award_label"
              name="award_labels_label_id@or"
              multi
              autocomplete
              promise={this.searchOrganizationAwardLabels}
              placeholder="Start typing ..."
              intlKeyPlaceholder="placeholder.start_typing"
              backspaceToRemoveMessage={''}
            />
          </Col> }

          <Col flex="1 1 auto" alignSelf="flex-end" right>
            <FilterActions {...this.props} />
          </Col>
        </Row>
      </Module>
    )
  }
}

export default enhance(FilterAwardsOfficeSignoff)
